import { render } from "./NewsLetters.vue?vue&type=template&id=f89e4e82"
import script from "./NewsLetters.vue?vue&type=script&lang=js"
export * from "./NewsLetters.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__